import { makeStyles } from '@material-ui/core';

export const notaFiscalStyles = makeStyles({
  tagContainer: {
    display: 'flex',
  },
  tag: {
    color: '#ffffff',
    paddingLeft: 6,
    paddingRight: 6,
    paddingTop: 5,
    paddingBottom: 5,
    fontSize: 11,
    fontWeight: 600,
    borderRadius: '0px !important',
    textAlign: 'center',
  },
  tagEmFaturamento: {
    backgroundColor: '#3286a8',
  },
  tagFaturado: {
    backgroundColor: '#2dc44d',
  },
  tagEmCancelamento: {
    backgroundColor: '#e88e18',
  },
  tagCancelado: {
    backgroundColor: '#e88e18',
  },
  tagErroTransmissao: {
    backgroundColor: '#b53838',
  },
  header: {
    margin: 'auto',
    paddingTop: 15,
  },
  headerErroCancelamento: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
  },
  titulo: {
    marginLeft: '1.2rem',
    fontSize: '2rem',
    fontWeight: '600',
    lineHeight: 1.6,
  },
  buttonIconNf: {
    marginRight: '20px',
  },
  actionButton: {
    height: '20px',
    display: 'flex',
    marginLeft: '3em',
  },
  link: {
    color: '#53c4e6',
    fontWeight: '600',
    textTransform: 'initial',
  },
  buscaAvancadaButton: {
    display: 'flex',
    justifyContent: 'flex-end',
    flexDirection: 'row',
    marginTop: 5,
    marginRight: 50,
  },
});
